import { ModuleWithProviders, NgModule } from '@angular/core';
import { StripeService } from './stripe.service';

@NgModule({
})
export class StripeModule {
    static forRoot(): ModuleWithProviders<StripeModule> {
    return {
        ngModule: StripeModule,
        providers: [
            StripeService
        ]
    };
}
}